/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker } from 'components/filters';
import {
  CopackAgreementSelect,
  OrderBrokerageAgreementSelect,
  SettlementSelect,
} from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
/* eslint-enable */
import { resolve as copackAgreementResolve } from '../../shared/actions/generated/copack-agreement.actions';
import { resolve as orderBrokerageAgreementResolve } from '../../shared/actions/generated/order-brokerage-agreement.actions';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  if (query.copackAgreement) {
    resolvedQuery.copackAgreement = await copackAgreementResolve(
      query.copackAgreement,
    );
  }
  if (query.orderBrokerageAgreement) {
    resolvedQuery.orderBrokerageAgreement =
      await orderBrokerageAgreementResolve(query.orderBrokerageAgreement);
  }
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function EntitySettlementFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.entityType === 'undefined' && (
          <FormGroup>
            <Label>Entitetstyp</Label>
            <Select
              instanceId="select-entityType"
              name="entityType"
              value={_.get(resolvedQuery, 'entityType', '')}
              onChange={handleChange}
              options={[
                { value: 'order', label: 'Order' || 'order' },
                {
                  value: 'purchaseOrder',
                  label: 'inköpsorder' || 'purchaseOrder',
                },
                { value: 'complaint', label: 'Reklamation' || 'complaint' },
                { value: 'manual', label: 'Manuell rad' || 'manual' },
                {
                  value: 'alcoholTaxAdjustment',
                  label: 'Alkoholskattesjustering' || 'alcoholTaxAdjustment',
                },
                { value: 'monthlyFee', label: 'Månadsavgift' || 'monthlyFee' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.entityId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.entity === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.cancelled === 'undefined' && (
          <FormGroup>
            <Label>makulerad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'cancelled') === undefined}
                onClick={() => {
                  handleChange('cancelled', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === true ||
                  _.get(resolvedQuery, 'cancelled') === 'true'
                }
                onClick={() => {
                  handleChange('cancelled', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === false ||
                  _.get(resolvedQuery, 'cancelled') === 'false'
                }
                onClick={() => {
                  handleChange('cancelled', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.copackAgreement === 'undefined' && (
          <FormGroup>
            <Label>Copackningsavtal</Label>
            <CopackAgreementSelect
              defaultOptions={false}
              instanceId="select-copackAgreement"
              name="copackAgreement"
              value={_.get(resolvedQuery, 'copackAgreement')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.orderBrokerageAgreement === 'undefined' && (
          <FormGroup>
            <Label>Orderförmedlaravtal</Label>
            <OrderBrokerageAgreementSelect
              defaultOptions={false}
              instanceId="select-orderBrokerageAgreement"
              name="orderBrokerageAgreement"
              value={_.get(resolvedQuery, 'orderBrokerageAgreement')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.agreementDetails === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.settlementDate === 'undefined' && (
          <FormGroup>
            <Label>Avräkningsdatum</Label>
            <DateRangePicker
              name="settlementDate"
              value={_.get(resolvedQuery, 'settlementDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.settlement === 'undefined' && (
          <FormGroup>
            <Label>Avräkning</Label>
            <SettlementSelect
              defaultOptions={false}
              instanceId="select-settlement"
              name="settlement"
              value={_.get(resolvedQuery, 'settlement')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.supplierOrganizationId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

EntitySettlementFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

EntitySettlementFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function EntitySettlementFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <EntitySettlementFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

EntitySettlementFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

EntitySettlementFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = {
  EntitySettlementFilterPanel,
  EntitySettlementFilterPanelModal,
};
